import { useEffect, useState } from 'react';
import { app } from '../app.ts';
import { useApp } from '../hooks.ts';
import { Icons } from './icons.tsx';

interface VersionMeta {
  id: string;
  label: string;
  createdAt: number;
  auto: boolean;
  by?: string;
}

export function VersionHistory() {
  const open = useApp('ui', () => app.ui.versionsOpen);
  const [list, setList] = useState<VersionMeta[]>([]);
  const [label, setLabel] = useState('');
  const load = () =>
    fetch(`/api/files/${app.fileId}/versions`)
      .then((r) => r.json())
      .then(setList)
      .catch(() => setList([]));
  useEffect(() => {
    if (open && app.fileId) void load();
  }, [open]);
  if (!open || !app.fileId) return null;
  const save = async () => {
    await fetch(`/api/files/${app.fileId}/versions`, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ label: label || 'Saved version', by: app.userName }) });
    setLabel('');
    void load();
  };
  const restore = async (v: VersionMeta) => {
    if (!confirm(`Restore "${v.label}" from ${new Date(v.createdAt).toLocaleString()}? You can undo this.`)) return;
    await fetch(`/api/files/${app.fileId}/versions/${v.id}/restore`, { method: 'POST' });
    app.setUI({ versionsOpen: false });
    app.toast('Version restored');
  };
  return (
    <div className="modal-backdrop" onPointerDown={(e) => e.target === e.currentTarget && app.setUI({ versionsOpen: false })}>
      <div className="modal">
        <header>
          <span>Version history</span>
          <button className="icon-btn" onClick={() => app.setUI({ versionsOpen: false })}>
            {Icons.close}
          </button>
        </header>
        <div className="body">
          <div className="row" style={{ marginBottom: 12 }}>
            <div className="field">
              <input placeholder="Name this version…" value={label} onChange={(e) => setLabel(e.target.value)} onKeyDown={(e) => (e.stopPropagation(), e.key === 'Enter' && save())} />
            </div>
            <button className="btn primary" onClick={save}>
              Save version
            </button>
          </div>
          {list.length === 0 && <div style={{ color: 'var(--text-2)' }}>No versions yet. Vellum also checkpoints automatically every 10 minutes while you edit.</div>}
          <div className="versions">
            {list.map((v) => (
              <div key={v.id} className="version">
                <img loading="lazy" src={`/api/files/${app.fileId}/versions/${v.id}/render?max=240`} alt="" />
                <div style={{ flex: 1 }}>
                  <b>{v.label}</b>
                  <div style={{ color: 'var(--text-2)' }}>
                    {new Date(v.createdAt).toLocaleString()} {v.by ? `· ${v.by}` : ''} {v.auto ? '· auto' : ''}
                  </div>
                </div>
                <button className="btn secondary" onClick={() => restore(v)}>
                  Restore
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
